import { Grid2, IconButton, Skeleton, Tooltip } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import TickerSkeleton from '../Skeleton/TickerSkeleton';
import socket from '../../utils/Socket';
import useBinance24hTicker from '../../socket/BinanceTickerSocket';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const TerminalHeaderTow = () => {

    // Hooks
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // States
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [checkedItems, setCheckedItems] = useState({
        "24h High": true,
        "24h Low": true,
        "24h Volume (Coin)": true,
        "24h Volume (USDT)": true,
    });

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleChange = (setting) => (event) => {
        const newChecked = {
            ...checkedItems,
            [setting]: event.target.checked,
        };
        setCheckedItems(newChecked);

        // persist
        localStorage.setItem('terminalCheckedItems', JSON.stringify(newChecked));
    };

    //custom code
    const queryParams = new URLSearchParams(location.search);
    const initialSymbol = queryParams.get("symbol");
    const [selectedSymbol, setSelectedSymbol] = useState(null);
    const [load, setLoad] = useState(true);
    const [tradePairDetail, setTradePairDetail] = useState({})
    const { tradePairData, tradePairLoading } = useSelector(state => state.tradePair);
    const { data, loading } = useBinance24hTicker(initialSymbol);

    useEffect(() => {
        if (!tradePairLoading) {
            let initialTradePair = {};
            if (initialSymbol) {
                initialTradePair = tradePairData?.data?.find((item) => item.symbol?.toUpperCase() === initialSymbol?.toUpperCase())
            } else {
                initialTradePair = tradePairData?.data?.[0] || {};
            }
            setTradePairDetail(initialTradePair);
            setSelectedSymbol(initialTradePair?.symbol);
            setLoad(false);

            // 24 h coin one & coin two change and delte  old dynamic volume keys
            const oldVolumeKeys = Object.keys(checkedItems).filter((key) => key.startsWith("24h Volume ("));
            oldVolumeKeys.forEach((key) => {
                delete checkedItems[key];
            });

            // add new dynamic volume keys
            setCheckedItems((prev) => {
                const newChecked = { ...prev };
                newChecked[`24h Volume (${initialTradePair?.coinOne})`] = true;
                newChecked[`24h Volume (${initialTradePair?.coinTwo})`] = true;
                return newChecked;
            });
        };
    }, [tradePairLoading, initialSymbol]);

    useEffect(() => {
        socket.connect(); //  connect socket once

        return () => {
            socket.disconnect(); //  cleanly close on unmount
        };
    }, []);


    useEffect(() => {
        if (!data) return;
        //  Ignore if symbol mismatch
        if (data.symbol !== initialSymbol) return;

        setTradePairDetail((prev) => {
            if (!prev) return prev;
            return {
                ...prev,
                lastPrice: data.lastPrice,
                livePrice: data.lastPrice,
                change24h: data.change24h,
                changePercent24h: data.changePercent24h,
                baseVolume24h: data.volume24h,
                quoteVolume24h: data.quoteVolume24h,
                high24h: data.high24h,
                low24h: data.low24h,
            };
        });
    }, [data, initialSymbol]);

    const formatNumber = (value, decimals = 2) => {
        const num = Number(value);
        if (!Number.isFinite(num)) return "--";
        return num.toFixed(decimals);
    };

    return (
        <div className='terminal-header-tow-main mt-20'>
            <Grid2 container spacing={0}>
                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    {
                        loading === true ?
                            <TickerSkeleton /> :
                            <div className='futures-tradeheader2-main' style={{ justifyContent: 'flex-start', gap: '20px' }}>
                                <div className='terminal-header-tow-main-card'>
                                    <div className='display-1' style={{ gap: '1px' }}>
                                        <div className='futures-menu-title display-1' style={{ gap: '3px' }}>
                                            <h1 className="gold-color">{selectedSymbol}</h1>
                                        </div>
                                    </div>

                                    <div>
                                        {!tradePairDetail?.livePrice ?
                                            <Skeleton variant="rectangular" sx={{ borderRadius: "5px", backgroundColor: "#2b3139" }} width={100} height={40} /> :
                                            <h3 className={Number(tradePairDetail?.livePrice) > 0 ? "green" : "red"}>
                                                {formatNumber(tradePairDetail?.livePrice, tradePairDetail?.priceDecimal)}
                                            </h3>
                                        }
                                    </div>

                                    {checkedItems["24h High"] && (
                                        <div>
                                            <span>24h High</span>
                                            <p>{formatNumber(tradePairDetail?.high24h, tradePairDetail?.priceDecimal)}</p>
                                        </div>
                                    )}
                                    {checkedItems["24h Low"] && (
                                        <div>
                                            <span>24h Low</span>
                                            <p>{formatNumber(tradePairDetail?.low24h, tradePairDetail?.priceDecimal)}</p>
                                        </div>
                                    )}
                                    {checkedItems[`24h Volume (${tradePairDetail?.coinOne})`] && (
                                        <div>
                                            <span>24h Volume ({tradePairDetail?.coinOne})</span>
                                            <p>{formatNumber(tradePairDetail?.baseVolume24h, tradePairDetail?.qtyDecimal)}</p>
                                        </div>
                                    )}
                                    {checkedItems[`24h Volume (${tradePairDetail?.coinTwo})`] && (
                                        <div>
                                            <span>24h Volume ({tradePairDetail?.coinTwo})</span>
                                            <p>{formatNumber(tradePairDetail?.quoteVolume24h, tradePairDetail?.priceDecimal)}</p>
                                        </div>
                                    )}



                                </div>
                                <div className='' style={{ paddingRight: '10px' }}>
                                    <Box sx={{ flexGrow: 0 }}>
                                        <Tooltip title="Ticker Preference">
                                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                                <MoreHorizIcon sx={{ color: 'var(--color-TextLink)' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Menu
                                            sx={{ mt: '45px' }}
                                            id="menu-appbar"
                                            anchorEl={anchorElUser}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchorElUser)}
                                            onClose={handleCloseUserMenu}
                                            PaperProps={{
                                                sx: {
                                                    background: 'var(--color-BasicBg)',
                                                },
                                            }}
                                        >
                                            {Object.keys(checkedItems).map((setting) => (
                                                <MenuItem key={setting} onClick={(e) => e.stopPropagation()}>
                                                    <Checkbox
                                                        checked={checkedItems[setting]}
                                                        onChange={handleChange(setting)}
                                                        inputProps={{ 'aria-label': `${setting} checkbox` }}
                                                    />
                                                    <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    </Box>
                                </div>
                            </div>
                    }
                </Grid2>
            </Grid2>
        </div>
    )
}

export default TerminalHeaderTow

